import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { groupFulfillmentOrderLineItems } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const VendorsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Vendors",
    cell: (row) => {
      const lineItems = groupFulfillmentOrderLineItems(row.items);
      const vendors = [
        ...new Set(lineItems.map((item) => item.vendor).filter(Boolean)),
      ];
      return vendors.join(", ");
    },
    expandedCsvCell: (row, expansionIndex) =>
      getExpandedItems(row)?.[expansionIndex]?.vendor ?? "",
  };
